import { Component, effect, input } from '@angular/core';
import { ChartDataset, ChartType, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    selector: 'gea-mes-piechart',
    templateUrl: './gea-mes-piechart.component.html',
    styleUrls: ['./gea-mes-piechart.component.scss'],
    imports: [BaseChartDirective]
})
export class GeaMesPiechartComponent {
  /*******************************************************
  * Input Injections                                     *
  ********************************************************/
  public labels = input<string[]>(['Good','Bad','New']);  // Array of Labels
  public colors = input<string[]>(['green','red','#f2f4f4']); // Array of colors
  public values = input<number[]>([]); // Array of Values

  /*******************************************************
  * Class Variables                                      *
  ********************************************************/
  protected pieChartType: ChartType = 'pie';
  protected pieChartOptions: ChartOptions = {
                                              responsive: true,
                                              maintainAspectRatio: false,
                                              animation: {
                                                duration: 0
                                              },
                                              elements:{
                                                arc: {
                                                  borderWidth: 1,
                                                  borderColor: 'gray'
                                                }
                                              },
                                              plugins: { 
                                                tooltip: { 
                                                  callbacks: {
                                                    label: function(tooltipItem) {
                                                      // This function will override the tooltip label for a segment of the pie chart to format as hh:mm:ss
                                                      let label:string = ""; 
                                                      const value:any = tooltipItem.raw; // Use tooltipItem.raw to get the original data value

                                                      if (value > 0) {
                                                        // Only set the label if value is non-negative

                                                        label = tooltipItem.dataset.label || '';
                                                        if (label) {
                                                          label += ': ';
                                                        }
                                                        
                                                        const hours = Math.floor(value / 3600);
                                                        const minutes = Math.floor((value % 3600) / 60);
                                                        const seconds = value % 60;
                                                        
                                                        // Format to hh:mm:ss
                                                        const formattedTime = [
                                                          hours.toString().padStart(2, '0'),
                                                          minutes.toString().padStart(2, '0'),
                                                          seconds.toString().padStart(2, '0')
                                                        ].join(':');
                                                        
                                                        label += formattedTime;
                                                      } 
                                                      return label;
                                                    }
                                                  }
                                                }
                                              }
                                            };
                                            
  protected pieChartData: ChartDataset[];

  protected pieChartLegend = false;

  constructor() {
    // Watch for changes in the values and colors signal to update the pie chart
    effect(() => {
      this.pieChartData = [{ 
                            data: this.values(), 
                            backgroundColor: this.colors() 
                          }];
    });
  }
}
